import { atom, selector, selectorFamily } from "recoil";
import ServiceAuth from "src/services/auth/authToken";
import ServicePatient from "src/services/patient/patient";

export const activeStepRegisterState = atom({
  key: "activeStepRegister",
  default: 0,
});

export const completedStepRegisterState = atom({
  key: "completedStepRegister",
  default: {},
});

export const rulesPasswordState = atom({
  key: "rulesPassword",
  default: {
    lengthIsValid: false,
    upperCaseLetterIsValid: false,
    lowerCaseLetterIsValid: false,
    findOneNumberIsValid: false,
  },
});

export const valuesFormRegisterState = atom({
  key: "valuesFormRegister",
  default: {
    uswRut: null,
    uswEmail: null,
    uswEmailConfirm: null,
    uswFonoMovil: null,
    uswCodFonoFijo1: null,
    uswFonoFijo1: null,
    uswNombres: null,
    uswApePat: null,
    uswApeMat: null,
    fechaNac: null,
    idgGenero: null,
    idgDescrip: null,
    isaCodigo: null,
    isaNombre: null,
    uswClave: null,
    uswRepetirClave: null,
    claveTemporal: null,
  },
});

export const errorsFormRegisterState = atom({
  key: "errorsFormRegister",
  default: {
    uswRut: [],
    uswEmail: [],
    uswEmailConfirm: [],
    uswFonoMovil: [],
    uswCodFonoFijo1: [],
    uswFonoFijo1: [],
    uswNombres: [],
    uswApePat: [],
    uswApeMat: [],
    fechaNac: [],
    idgGenero: [],
    isaCodigo: [],
    uswClave: [],
    uswRepetirClave: [],
    phoneEmpty: [],
    matchPassword: [],
    claveTemporal: [],
  },
  effects_UNSTABLE: [
    ({ onSet }) => {
      onSet((newValue) => {});
    },
  ],
});

const storedData = sessionStorage.getItem("valuesFormReservationGuest");
const valuesReservationGuestData = storedData
  ? JSON.parse(storedData)
  : {
      uprRut: null,
      usuApePat: null,
      usuApeMat: null,
      usuNombres: null,
      usuFono: null,
      usuCelular: null,
      ageEmail: null,
      ageEmailConfirm: null,
      fechaNac: null,
      isaCodigo: null,
    };

export const valuesFormReservationGuestState = atom({
  key: "valuesFormReservationGuest",
  default: valuesReservationGuestData,
  effects: [
    ({ onSet }) => {
      onSet((newValue) => {
        sessionStorage.setItem(
          "valuesFormReservationGuest",
          JSON.stringify(newValue),
        );
      });
    },
  ],
});

const storedDataImagenologia = sessionStorage.getItem(
  "valuesFormReservationImagenologiaGuest",
);
const valuesReservationGuestImagenologiaData = storedDataImagenologia
  ? JSON.parse(storedDataImagenologia)
  : {
      uprRut: null,
      usuApePat: null,
      usuApeMat: null,
      usuNombres: null,
      usuFono: null,
      usuCelular: null,
      ageEmail: null,
      ageEmailConfirm: null,
      fechaNac: null,
    };

export const valuesFormReservationGuestImagenologiaState = atom({
  key: "valuesFormReservationImagenologiaGuest",
  default: valuesReservationGuestImagenologiaData,
  effects: [
    ({ onSet }) => {
      onSet((newValue) => {
        sessionStorage.setItem(
          "valuesFormReservationImagenologiaGuest",
          JSON.stringify(newValue),
        );
      });
    },
  ],
});

export const errorsReservationGuestState = atom({
  key: "errorsReservationGuest",
  default: {
    uprRut: [],
    usuNombres: [],
    usuApePat: [],
    usuApeMat: [],
    usuFono: [],
    ageEmail: [],
    ageEmailConfirm: [],
    fechaNac: [],
    isaCodigo: [],
  },
  effects_UNSTABLE: [
    ({ onSet }) => {
      onSet((newValue) => {});
    },
  ],
});

export const valuesFormReservationUserState = atom({
  key: "valuesFormReservationUser",
  default: {
    uswLogin: "",
    uswClave: "",
  },
});

export const errorsReservationUserState = atom({
  key: "errorsReservationUser",
  default: {
    uswLogin: [],
    uswClave: [],
  },
});

export const verifyTokenUserRegisteredState = selector({
  key: "verifyTokenUserRegistered",
  get: async () => {
    return await (
      await ServiceAuth.verifyTokenRegistered()
    ).data;
  },
});

export const userLoggedState = atom({
  key: "userLogged",
  default: null,
});

export const listReservationsRecentsFetchState = selectorFamily({
  key: "listReservationsRecentsFetch",
  get:
    (rut) =>
    async ({ get }) => {
      get(reservationsRecentsState);
      const { data } = await ServicePatient.getReservations(rut, "recientes");
      return data;
    },
});

export const listReservationsHistoryFetchState = selectorFamily({
  key: "listReservationsHistoryFetch",
  get:
    (rut) =>
    async ({ get }) => {
      get(reservationsHistoryState);
      const { data } = await ServicePatient.getReservations(rut, "historial");
      return data;
    },
});

export const reservationsRecentsState = atom({
  key: "reservationsRecents",
  default: [],
});

export const reservationsHistoryState = atom({
  key: "reservationsHistory",
  default: [],
});

//---------------------------------------------

const format = (inputDate) => {
  let date, month, year;

  date = inputDate.getDate();
  month = inputDate.getMonth() + 1;
  year = inputDate.getFullYear();

  date = date.toString().padStart(2, "0");

  month = month.toString().padStart(2, "0");

  let hh =
    inputDate.getHours() < 10
      ? "0" + inputDate.getHours()
      : inputDate.getHours();
  let mi =
    inputDate.getMinutes() < 10
      ? "0" + inputDate.getMinutes()
      : inputDate.getMinutes();
  let ss =
    inputDate.getSeconds() < 10
      ? "0" + inputDate.getSeconds()
      : inputDate.getSeconds();

  return `${date}/${month}/${year} ${hh}:${mi}:${ss}`;
};

export const listViewerExamsFetchState = selectorFamily({
  key: "listViewerExamsFetch",
  get:
    (rut) =>
    async ({ get }) => {
      get(viewerExamsState);

      rut = rut.trim();
      let dv = rut.substring(rut.length - 1, rut.length);
      let cadena = rut.substring(0, rut.length - 1);

      let rutdv = cadena + "-" + dv;

      const { data } = await ServicePatient.getViewerExams(rutdv);

      // let prueba = JSON.stringify(data.data);
      // let myJson = JSON.parse(prueba);

      // if (typeof data === "string") return [];

      // if (JSON.stringify(data).indexOf("[")) {
      //   let arr = [];

      //   // let myDate = new Date(Date.parse(myJson.fechaExamen));
      //   // let strDate = format(myDate); //myDate.getFullYear().toString() + "/" + myDate.getMonth().toString()

      //   let obj = {
      //     id: "0",
      //     fechaExamen: format(new Date(Date.parse(myJson.fechaExamen))),
      //     id_paciente: myJson.id_paciente,
      //     codigo: myJson.codigo,
      //     nombre: myJson.nombre,
      //     nombreDocumento: myJson.nombreDocumento,
      //     idInforme: myJson.idInforme,
      //     numero_acceso: myJson.numero_acceso,
      //     rutaDocumento: myJson.rutaDocumento,
      //     rutaImagen: myJson.rutaImagen,
      //     sucursal: myJson.sucursal,
      //   };
      //   arr.push(obj);
      //   return arr;
      // } else {
      //   let arr = [];
      //   myJson.map((o) => {
      //     let obj = {
      //       id: "0",
      //       fechaExamen: format(new Date(Date.parse(o.fechaExamen))),
      //       id_paciente: o.id_paciente,
      //       codigo: o.codigo,
      //       nombre: o.nombre,
      //       nombreDocumento: o.nombreDocumento,
      //       idInforme: o.idInforme,
      //       numero_acceso: o.numero_acceso,
      //       rutaDocumento: o.rutaDocumento,
      //       rutaImagen: o.rutaImagen,
      //       sucursal: o.sucursal,
      //     };
      //     arr.push(obj);
      //   });
      //   return arr;
      // }

      const json = data.data.map((o) => ({
        id: "0",
        fechaExamen: format(new Date(Date.parse(o.fechaExamen))),
        id_paciente: o.id_paciente,
        codigo: o.codigo,
        nombre: o.nombre,
        nombreDocumento: o.nombreDocumento,
        idInforme: o.idInforme,
        numero_acceso: o.numero_acceso,
        rutaDocumento: o.rutaDocumento,
        rutaImagen: o.rutaImagen,
        sucursal: o.sucursal,
      }));

      return json;
    },
});

export const viewerExamsState = atom({
  key: "viewerExams",
  default: [],
});

//---------------------------------------------

export const listViewerExamsLabFetchState = selectorFamily({
  key: "listViewerExamsLabFetch",
  get:
    (rut) =>
    async ({ get }) => {
      get(viewerExamsLabState);

      rut = rut.trim();
      let dv = rut.substring(rut.length - 1, rut.length);
      let cadena = rut.substring(0, rut.length - 1);
      let rutdv = cadena + "-" + dv; // "7405554-0"; // "15592352-0";//
      const { data } = await ServicePatient.getViewerExamsLab(rutdv);

      // let prueba = JSON.stringify(data);
      // let myJson = JSON.parse(prueba);

      // if (typeof data === "string") return [];

      let json = data.data.flatMap((sucursalItem) =>
        sucursalItem.ordenes.map((orden) => ({
          sucursal: sucursalItem.sucursal,
          ...orden,
        })),
      );

      return json;
    },
});

export const viewerExamsLabState = atom({
  key: "viewerExamsLab",
  default: [],
});

//---------------------------------------------

export const listViewerExamsLabBase64FetchState = selectorFamily({
  key: "listViewerExamsLabBase64Fetch",
  get:
    (queryParameters) =>
    async ({ get }) => {
      get(viewerExamsLabBase64State);

      const { data } = await ServicePatient.getViewerExamsLabBase64(
        queryParameters.numeroOrden,
        queryParameters.numeroExterno,
        queryParameters.ordenValida,
        queryParameters.tipoDocumento,
        queryParameters.numeroDocumento,
        queryParameters.sucursalOrigen,
      );

      // let prueba = JSON.stringify(data);
      // let myJson = JSON.parse(prueba);

      // if (typeof data === "string") return [];

      return data.data.reporte;
    },
});

export const viewerExamsLabBase64State = atom({
  key: "viewerExamsLabBase64",
  default: [],
});

//---------------------------------------------
export const resendCodeConfirmationState = atom({
  key: "resendCodeConfirmation",
  default: false,
});

export const sendEmailFetchState = selectorFamily({
  key: "sendEmailFetch",
  get:
    (queryParameters) =>
    async ({ get }) => {
      return await ServicePatient.getEmail(queryParameters);
    },
});

export const sendEmailState = atom({
  key: "sendEmail",
  default: [],
});

//---------------------------------------------
export const readFileTextFetchState = selectorFamily({
  key: "readFileTextFetch",
  get:
    () =>
    async ({ get }) => {
      return await ServicePatient.getBodyHtml();
    },
});
